import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setApiKey, setApiKeyModalVisible } from '../actions/commonActions'

const AppInitializer = ({ dispatch, apiKey, showApiKeyModal }) => {
  useEffect(() => {
    // Check if API key exists in localStorage
    const storedApiKey = localStorage.getItem('valhalla_api_key')

    if (storedApiKey && !apiKey) {
      // If we have a stored API key but it's not in Redux state, set it
      dispatch(setApiKey(storedApiKey))
    } else if (!storedApiKey && !apiKey) {
      // If no API key exists anywhere, show the modal
      dispatch(setApiKeyModalVisible(true))
    }
  }, [dispatch, apiKey])

  return null // This component doesn't render anything
}

AppInitializer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  apiKey: PropTypes.string,
  showApiKeyModal: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
  apiKey: state.common.apiKey,
  showApiKeyModal: state.common.showApiKeyModal,
})

export default connect(mapStateToProps)(AppInitializer)
